import PortalClienteService from "services/bases/PortalClienteService";

class RecursosReservaveisService extends PortalClienteService{
    async ListarPorDireito(direitoid){
        return await this.get(`recursosreservaveis/ListarRecursosPorDireito?direitoId=${direitoid}`)
    }
}

export default new RecursosReservaveisService();